import React from "react"
import { useSelector } from "react-redux"
import {
  selectAviaSearchCurrency,
  selectAviaSearchPassengers,
} from "../../../../../app/reducers/book/aviaSearchSlice"
import { CURRENCIES, formatMoney } from "../../../../../variables/common"
import Button from "../ui/Button"
import { Trans } from "react-i18next"
import { parsePassengersCount } from "../../utils/processing/search"

const DetailsBottom = ({ passengers, price, currency, handleBundle, t, isLoading }) => {
  // const { children, adults, infants } = useSelector(selectAviaSearchPassengers)

  const { children = 0, adults = 0, infants = 0 } = passengers ?? {}

  const curSymbol = CURRENCIES.find((item) => item.code === currency).symbol

  const amountStr = formatMoney(price, currency)

  const amount = amountStr.replace(/\s*[^\d\s,]+\.?\s*$/, "")

  // const count = parsePassengersCount(passengers)
  const count = children + adults + infants

  return (
    <div className="flex flex-col gap-4 px-4 py-2 sm:px-6 md:px-8">
      <div className="text-center mb-2 flex flex-col gap-1">
        <div className="text-4xl sm:text-3xl xs:text-2xl font-semibold text-dark-gray whitespace-nowrap">
          {`${amount}${curSymbol}`}
        </div>
        <div className="text-[18px] sm:text-[16px] xs:text-[14px] text-dark-red/50">
          <Trans
            i18nKey="admin.passagers_count"
            components={{ count: <span /> }}
            values={{ count }}
          />
        </div>
      </div>

      <div className="flex justify-center w-full">
        <Button
          isLoading={isLoading}
          className="w-full sm:w-[80%]"
          size="md"
          onClick={(e) => {
            e.stopPropagation()
            handleBundle()
          }}
        >
          {t("admin.reserve")}
        </Button>
      </div>
    </div>
  )
}

export default DetailsBottom
